<template>
  <div class="block block-bordered">
    <div
      v-if="data.id !== 1 && data.type === 'products'"
      class="block-options mt-2 mr-4 float-right"
    >
      <button
        class="btn btn-danger"
        type="button"
        @click="deleteSectionBlock(data.id)"
      >
        <i class="fa fa-times"></i>
      </button>
    </div>
    <div class="block-header block-header-default">
      <input
        placeholder="productwidget/serviceswidget"
        v-if="data.type === 'products'"
        type="text"
        class="border-0"
        v-model="data.title"
      />
      <h3
        class="block-title"
        v-if="
          data.type !== 'html' &&
          data.type !== 'datewidget' &&
          data.type !== 'cityheat' &&
          data.type !== 'water' &&
          data.type !== 'familySituation' &&
          data.type !== 'insuranceForLead'
        "
      >
        <small v-if="data.type !== 'products'">
          {{ data.subtitle[lang] }}
        </small>
      </h3>
      <h3 class="block-title" v-else>
        {{ data.title }}
      </h3>
      <div
        class="block-options"
        v-if="data.type === 'html' || data.type === 'datewidget'"
      >
        <button
          type="button"
          class="btn-block-option"
          data-toggle="block-option"
          data-action="content_toggle"
        >
          <i class="si si-arrow-up"></i>
        </button>
      </div>
      <div class="block-options" v-if="data.type === 'products'">
        <button
          v-if="data.id === 1"
          class="btn-block-option"
          type="button"
          data-toggle="modal"
          data-target="#modal-block-add-product"
        >
          <i class="fa fa-plus text-primary-dark"></i>
        </button>
        <button
          v-if="data.id === 1"
          class="btn-block-option"
          type="button"
          @click="addSection"
        >
          <i class="fa fa-clone text-primary-dark"></i>
        </button>
        <button
          type="button"
          class="btn-block-option"
          data-toggle="block-option"
          data-action="content_toggle"
        >
          <i class="si si-arrow-up"></i>
        </button>
      </div>
      <div class="block-options" v-else-if="data.type === 'suppliers'">
        <button
          class="btn-block-option"
          type="button"
          data-toggle="modal"
          data-target="#modal-block-add-supplier"
          @click="getProducSupplier(data.product)"
        >
          <i class="fa fa-plus text-primary-dark"></i>
        </button>
        <button
          type="button"
          class="btn-block-option"
          data-toggle="block-option"
          data-action="content_toggle"
        >
          <i class="si si-arrow-up"></i>
        </button>
      </div>
    </div>
    <div class="block-content">
      <draggable
        v-if="data.type === 'products'"
        tag="div"
        class="row"
        :group="data.group"
        @end="onEndSection"
        v-model="
          $store.state.forms.formStateData.data.fields.filter(
            (x) => x.id === data.id && x.type === data.type
          )[0].products
        "
      >
        <div class="col-md-3 mb-3" v-for="item in data.products" :key="item.id">
          <div class="mt-2 mb-2 text-secondary">
            <label :for="'default' + item.id" class="font-size-sm">
              <input
                type="checkbox"
                :id="'default' + item.id"
                :value="item.id"
                v-model="
                  $store.state.forms.formStateData.data.fields.filter(
                    (x) => x.id === data.id && x.type === data.type
                  )[0].defaultProducts
                "
              />
              Set Default
            </label>
          </div>
          <div class="utility">
            <div for="product-8">
              <button
                class="btn btn-danger float-right m-1"
                style="right: 0; position: absolute"
                @click="deleteProduct(item)"
              >
                <i class="fas fa-times"></i>
              </button>
              <img :src="getImage(item.icon)" />
              <span>{{ item.name[lang] }}</span>
              <a style="z-index: 110" class="more">More info</a>
            </div>
          </div>
        </div>
      </draggable>
      <div v-if="data.type === 'html'">
        <div v-if="data.html" v-html="data.html"></div>
      </div>
      <draggable
        v-if="data.type === 'suppliers' && data.group != 'insurance'"
        tag="div"
        class="row"
        :group="data.group"
        v-model="data.suppliers"
      >
        <table
          class="
            js-table-checkable
            table table-hover table-vcenter
            js-table-checkable-enabled
          "
          v-if="
            data.group === 'gas' ||
            data.group === 'electricity' ||
            data.group === 'electricityandgas'
          "
        >
          <thead>
            <tr>
              <th class="text-center" style="width: 70px"></th>
              <th width="15%">Aanbieder</th>
              <th class="d-sm-table-cell">Pakket</th>
              <th class="text-center d-sm-table-cell" style="width: 20%">
                Welkomstpremie
              </th>
              <th class="text-center d-sm-table-cell">Per jaar</th>
              <th class="d-sm-table-cell" width="170px"></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in data.suppliers" :key="item.id">
              <td class="text-center">
                <div
                  class="
                    custom-control custom-radio custom-control-primary
                    d-inline-block
                  "
                >
                  <input
                    type="radio"
                    class="custom-control-input"
                    :id="'row' + item.id"
                    :name="'row' + data.type"
                  />
                  <label
                    class="custom-control-label"
                    :for="'row' + item.id"
                  ></label>
                </div>
              </td>
              <td>
                <img
                  v-if="item.logo"
                  class="img-fluid w-50"
                  :src="getImage(item.logo)"
                />
              </td>
              <td class="d-sm-table-cell">
                {{ parseJSONSupplierName(item.name, lang) }}
              </td>
              <td class="text-center d-sm-table-cell">
                <p class="font-w600 mb-1">€..</p>
                <p class="text-muted mb-0">+...</p>
              </td>
              <td class="text-center d-sm-table-cell">€...</td>
              <td>
                <button class="btn btn-danger" @click="deleteSupplier(item.id)">
                  <span style="color: #fff">
                    <i class="fas fa-times"></i>
                  </span>
                </button>
                <div class="mt-2 mb-2 d-inline-block ml-2">
                  <label
                    :for="data.group + '_default' + item.id"
                    class="font-size-sm"
                  >
                    <input
                      @change="setEnergieDefault(data.group, item.rate_period)"
                      type="radio"
                      :id="data.group + '_default' + item.id"
                      :name="data.group + '_default'"
                      :value="item.id"
                      v-model="data.default"
                    />
                    Set Default
                  </label>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div
          v-if="
            data.group !== 'gas' &&
            data.group !== 'electricity' &&
            data.group !== 'electricityandgas' &&
            data.group !== 'insurance'
          "
          class="col-md-12 mb-3"
          v-for="itemGroup in groupBy(data.suppliers, 'supplier_id')"
          :key="itemGroup[0].id"
        >
          <h4 class="mb-0 text-info">
            <div class="custom-control custom-switch mb-1">
              <input
                type="radio"
                class="custom-control-input"
                :id="'example-sw-custom' + itemGroup[0].id"
                :name="data.group + 'Default'"
                :value="itemGroup[0].supplier_id"
                v-model="data.groupDefault"
                @change="setGroupDefault(itemGroup[0].supplier_id)"
              />
              <label
                class="custom-control-label"
                :for="'example-sw-custom' + itemGroup[0].id"
                >{{ itemGroup[0].title }}
              </label>
            </div>
          </h4>
          <div
            class="row mt-3"
            v-for="(itemProvider, key1) in groupBy(itemGroup, 'category_field')"
            :key="key1"
          >
            <div class="col-md-12">
              <h5 class="mb-0 text-success">
                {{
                  itemProvider[0].category_name
                    ? itemProvider[0].category_name[lang]
                    : "Package"
                }}
              </h5>
            </div>
            <div class="col-md-12">
              <draggable
                tag="div"
                class="row"
                :id="
                  itemProvider[0].category_field +
                  '_' +
                  itemProvider[0].supplier_id
                "
                @end="onEnd"
              >
                <div
                  v-for="(item, key) in itemProvider"
                  :key="key"
                  class="col-md-3 mb-3"
                >
                  <div class="mt-2 mb-2">
                    <label
                      :for="
                        data.group +
                        '_' +
                        item.category_field +
                        '_default' +
                        item.id
                      "
                      class="font-size-sm"
                    >
                      <input
                        type="radio"
                        :id="
                          data.group +
                          '_' +
                          item.category_field +
                          '_default' +
                          item.id
                        "
                        :name="
                          data.group +
                          '_' +
                          item.category_field +
                          '_default_' +
                          item.supplier_id
                        "
                        :value="item.id"
                        v-model="item.default"
                        @change="
                          setDefault(
                            item.id,
                            item.supplier_id,
                            item.category_field
                          )
                        "
                      />Set Default
                    </label>
                  </div>
                  <div class="utility">
                    <div for="product-8">
                      <button
                        class="btn btn-danger float-right m-1"
                        style="right: 0; position: absolute"
                        @click="deleteSupplier(item.id)"
                      >
                        <i class="fas fa-times"></i>
                      </button>
                      <img
                        :v-if="item.logo && item.logo !== null"
                        :src="getImage(item.logo)"
                      />
                      <span>{{ parseJSONSupplierName(item.name, lang) }}</span>
                      <a style="z-index: 110" class="more">More info</a>
                    </div>
                  </div>
                </div>
              </draggable>
            </div>
          </div>
        </div>
      </draggable>

      <div
        v-if="data.type === 'suppliers' && data.group == 'insurance'"
        v-for="item in suppliersByCategorized"
        :key="item.supplier"
      >
        <div v-for="item2 in item.categories" :key="item2.category">
          <table
            class="
              js-table-checkable
              table table-hover table-vcenter
              js-table-checkable-enabled
            "
            v-if="item2.propositions && item2.propositions[0]"
          >
            <thead>
              <tr>
                <th class="text-center" style="width: 70px"></th>
                <th width="15%">Aanbieder</th>
                <th class="d-sm-table-cell">Pakket</th>
                <th class="text-center d-sm-table-cell" style="width: 20%">
                  Welkomstpremie
                </th>
                <th class="text-center d-sm-table-cell">Per jaar</th>
                <th class="d-sm-table-cell" width="170px"></th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item3 in item2.propositions" :key="item3.id">
                <td class="text-center">
                  <div
                    class="
                      custom-control custom-radio custom-control-primary
                      d-inline-block
                    "
                  >
                    <input
                      type="radio"
                      class="custom-control-input"
                      :id="'row' + item3.id"
                      :name="'row' + data.type"
                    />
                    <label
                      class="custom-control-label"
                      :for="'row' + item3.id"
                    ></label>
                  </div>
                </td>
                <td>
                  <img
                    v-if="item3.logo"
                    class="img-fluid w-50"
                    :src="getImage(item3.logo)"
                  />
                </td>
                <td class="d-sm-table-cell">
                  {{ parseJSONSupplierName(item3.name, lang) }}
                </td>
                <td class="text-center d-sm-table-cell">
                  <p class="font-w600 mb-1">€..</p>
                  <p class="text-muted mb-0">+...</p>
                </td>
                <td class="text-center d-sm-table-cell">€...</td>
                <td>
                  <button
                    class="btn btn-danger"
                    @click="deleteProposition(item3.id)"
                  >
                    <span style="color: #fff">
                      <i class="fas fa-times"></i>
                    </span>
                  </button>
                  <div class="mt-2 mb-2 d-inline-block ml-2">
                    <label
                      :for="data.group + '_default' + item3.id"
                      class="font-size-sm"
                    >
                      <input
                        @click="setCheckBoxes(item3)"
                        type="checkbox"
                        :id="data.group + '_default' + item3.id"
                        :name="data.group + '_default'"
                        :value="item3.id"
                        :checked="item3.status"
                      />
                      Select
                    </label>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>

      <div v-if="data.type === 'datewidget'">
        <DateWidget></DateWidget>
      </div>
      <div v-if="data.type === 'familySituation'">
        <FamilySituation></FamilySituation>
      </div>
      <div v-if="data.type === 'insuranceForLead'">
        <InsuranceForLead></InsuranceForLead>
      </div>
      <div v-if="data.type === 'cityheat'">
        <Cityheat></Cityheat>
      </div>
      <div v-if="data.type === 'water'">
        <Water></Water>
      </div>
      <div v-if="data.type === 'commentWidget'">
        <Comment
          :comment="data.comment"
          :fromGroup="data.fromGroup"
          :id="data.id"
          :from="'editor'"
        ></Comment>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import draggable from "vuedraggable";
import DateWidget from "../widgets/DateWidget";
import FamilySituation from "../widgets/FamilySituation";
import InsuranceForLead from "../widgets/InsuranceForLead";
import Cityheat from "../widgets/Cityheat";
import Water from "../widgets/Water";
import Comment from "../widgets/Comment";
import _ from "lodash";

export default {
  name: "Section",
  components: {
    draggable,
    DateWidget,
    FamilySituation,
    InsuranceForLead,
    Cityheat,
    Water,
    Comment,
  },
  props: ["data", "index"],
  computed: {
    ...mapState({
      products: (state) => state.products.products,
    }),
    HasDuration() {
      return (
        this.form.data.fields[this.index].filter((a) => a.type === "duration")
          .length > 0
      );
    },
    suppliersByCategorized() {
      return this.data.suppliers
        ? _.chain(this.data.suppliers)
            .groupBy("supplier_id")
            .map((value, key) => ({
              supplier: key,
              id: key,
              categories: _.chain(value)
                .groupBy("category_field")
                .map((value, key) => ({
                  category: key,
                  id: key,
                  propositions: value,
                }))
                .value(),
            }))
            .value()
        : null;
    },
  },
  methods: {
    ...mapActions({
      getSupplier: "suppliers/getSupplier",
    }),
    onEndSection() {
      let sectionsList =
        this.$store.state.forms.formStateData.data.fields.filter(
          (x) =>
            !Array.isArray(x) && x.group == "sections" && x.type == "products"
        );
      let selecteds = this.selectedProducts;
      sectionsList.map((item) => {
        item.defaultProducts = [];
        item.products.map((product) => {
          if (selecteds.includes(product.id)) {
            item.defaultProducts.push(product.id);
          }
        });
      });
    },
    deleteSectionBlock: function (id) {
      //for delete products inside the section
      this.form.data.fields
        .filter((e) => e.id === id)[0]
        .products.map((item) => {
          this.deleteProduct(item);
        });
      this.form.data.fields = this.form.data.fields.filter((e) => e.id !== id);
    },
    addSection: function () {
      let lastItem = this.form.data.fields[this.form.data.fields.length - 1];
      let newId =
        lastItem.length > 0
          ? lastItem[lastItem.length - 1].id + 1
          : this.form.data.fields.length * 10;
      this.$store.state.forms.formStateData.data.fields.push({
        id: newId,
        group: "sections",
        type: "products",
        title: "",
        description: {
          nl: "",
          en: "",
        },
        css: "custom css",
        products: [],
        defaultProducts: [],
      });
    },
    deleteProduct: function (item) {
      this.form.data.fields = this.form.data.fields.filter(
        (e) => e.product !== item.id
      );

      this.form.data.fields.forEach((x, key) => {
        if (
          Array.isArray(x) &&
          x.filter((e) => e.product === item.id).length > 0
        ) {
          this.form.data.fields.splice(key, 1);
        }
      });

      this.form.data.fields.find((x) => x.id === this.data.id).products =
        this.form.data.fields
          .find((x) => x.id === this.data.id)
          .products.filter((e) => e.id !== item.id);

      this.form.data.fields.find((x) => x.id === this.data.id).defaultProducts =
        this.form.data.fields
          .find((x) => x.id === this.data.id)
          .defaultProducts.filter((e) => e !== item.id);

      if (
        (!this.findItem(1) && item.id === 2) ||
        (!this.findItem(2) && item.id === 1)
      ) {
        this.form.data.fields.forEach((x, key) => {
          if (
            Array.isArray(x) &&
            x.filter((e) => e.group === "electricityandgas").length > 0
          ) {
            this.form.data.fields.splice(key, 1);
          }
        });
      }
    },
    deleteSupplier: function (id) {
      let supplier_id = null;
      const formData = this.form.data.fields[this.index].find(
        (x) => x.id === this.data.id
      );

      if (formData.product === 8) {
        supplier_id = formData.suppliers.filter((e) => e.id === id)[0]
          .supplier_id;
      }

      this.form.data.fields[this.index].find(
        (x) => x.id === this.data.id
      ).suppliers = this.form.data.fields[this.index]
        .find((x) => x.id === this.data.id)
        .suppliers.filter((e) => e.id !== id);

      if (
        formData.product === 8 &&
        formData.suppliers.filter((f) => f.supplier_id === supplier_id)
          .length === 0
      ) {
        this.form.data.fields[this.index].find(
          (x) => x.id === this.data.id
        ).groupDefaultOld = null;

        this.form.data.fields[this.index].find(
          (x) => x.id === this.data.id
        ).groupDefault = null;
      }

      let temp = this.form.data.fields[this.index];

      if (
        temp.find((x) => x.type === "suppliers").default &&
        temp.find((x) => x.type === "suppliers").default === id
      ) {
        temp.find((x) => x.type === "suppliers").default = null;
        temp.find((x) => x.type === "duration").default = 0;
        if (temp.find((x) => x.type === "suppliers").suppliers.length > 0) {
          temp
            .find((x) => x.type === "suppliers")
            .suppliers.forEach((a) => (a.disabled = 0));
        }
      }
    },
    getProducSupplier(id) {
      this.$store.state.suppliers.index = this.index;
      this.getSupplier(id);
    },
    findItem: function (id) {
      let status = true;
      this.form.data.fields
        .filter((x) => x.type === "products")
        .forEach((x) => {
          if (x.products.find((item) => item.id === id)) {
            status = false;
          }
        });
      return status;
    },
    //ok
    setDefault(current, supplier_id, category_field) {
      this.form.data.fields[this.index]
        .find((x) => x.type === "suppliers")
        .suppliers.forEach((x) => {
          if (
            x.default &&
            x.id !== current &&
            x.supplier_id === supplier_id &&
            x.category_field === category_field
          ) {
            x.default = null;
          }
        });
    },
    //ok
    setGroupDefault(supplier) {
      this.form.data.fields[this.index].find(
        (x) => x.type === "suppliers"
      ).groupDefaultOld = supplier;
      this.form.data.fields[this.index]
        .find((x) => x.type === "suppliers")
        .suppliers.forEach((x) => {
          if (x.supplier_id === supplier) {
            x.show = 1;
          } else {
            x.show = 0;
          }
        });
    },
    setEnergieDefault(group, rate_period) {
      this.form.data.fields[this.index].find(
        (x) => x.type === "duration" && x.group === group
      ).default = rate_period;

      this.form.data.fields[this.index]
        .find((x) => x.type === "suppliers")
        .suppliers.forEach((x) => {
          if (x.rate_period === rate_period) {
            x.disabled = 0;
          } else {
            x.disabled = 1;
          }
        });
    },
    setCheckBoxes(proposition) {
      if (!this.HasDuration) {
        this.setStatus(proposition);
      }
    },
    setStatus(proposition) {
      if (proposition.status === 1) {
        proposition.status = 0;
      } else {
        proposition.status = 1;
      }
    },
    deleteProposition(id) {
      this.form.data.fields[this.index].find(
        (x) => x.id === this.data.id
      ).suppliers = this.form.data.fields[this.index]
        .find((x) => x.id === this.data.id)
        .suppliers.filter((e) => e.id !== id);
    },
    onEnd(event) {
      let suppliers = this.data.suppliersReOrder
        ? this.data.suppliersReOrder
        : this.data.suppliers;
      let params = event.from.id.split("_");
      let groupedSuppliers = Object.values(
        suppliers.filter(
          (x) =>
            x.category_field === params[0] &&
            x.supplier_id === parseInt(params[1])
        )
      );
      let newIndex = suppliers.indexOf(groupedSuppliers[event.newIndex]);
      // let oldIndex = suppliers.indexOf(groupedSuppliers[event.oldIndex])
      if (event.newIndex !== event.oldIndex) {
        const reorderedItems = [
          ...suppliers.slice(0, newIndex),
          groupedSuppliers[event.oldIndex],
          ...suppliers.slice(newIndex),
        ];
        let result = this.uniqueArray(reorderedItems, "id");
        this.$store.state.forms.formStateData.data.fields[this.index].filter(
          (x) => x.type === "suppliers"
        )[0].suppliersReOrder = result;
        /*

            if((newIndex - oldIndex) !== 1 && (newIndex - oldIndex) !== -1) {
                suppliers.splice(newIndex, 1, groupedSuppliers[event.oldIndex])
                suppliers.splice(oldIndex, 1, groupedSuppliers[event.newIndex])
            } else {
                let temp = suppliers[oldIndex];
                suppliers[oldIndex] = suppliers[newIndex];
                suppliers[newIndex] = temp;
            }

            this.$store.state.forms.formStateData.data.fields[this.index].filter(
                x => x.type === 'suppliers'
            )[0].suppliers = suppliers
            */
      }
    },
    parseJSONSupplierName(text, language) {
      try {
        return JSON.parse(text)[language];
      } catch (e) {
        return text;
      }
    },
  },
};
</script>

<style scoped>
.utility img {
  max-width: 40px;
  display: block;
  margin: 0 auto;
  margin-top: 25px;
}

.utility input {
  display: none;
}

.utility div {
  display: block;
  position: relative;
  border: 1px solid #a0a0a0;
  text-align: center;
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
  height: 160px;
  cursor: pointer;
  transition: background-color 0.2s, box-shadow 0.2s;
}

.utility .more {
  width: 100%;
  background: #f5fbfd;
  display: block;
  text-align: center;
  color: #1678aa;
  padding: 10px;
  position: absolute;
  bottom: 0;
  left: 0;
  font-weight: normal;
  font-size: 14px;
}
</style>
